import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
  MotifIcon,
} from '@ey-xd/motif-react';
import {
  navigationIcClose24px,
  alertIcWarning24px,
  alertIcError24px,
  alertIcErrorOutline24px,
} from '@ey-xd/motif-react/assets/icons';
import { BodyContent, HeaderWrapper, ParagraphStyle } from './styles/modalStyles';
import rightArrowImage from '../../assets/icons/right-arrow.png';
import { BUTTON_TITLE } from '../../../constants/commonConstants';
import {
  All_Month_Data_State,
  Current_User,
  Pl_Failure_Modal_State,
  Pl_Submit_Success_Modal_State,
  Recoil_Gcsp_Quarter_State,
  System_Date_Time_State,
} from '../../../recoil/recoil';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  submitGCSPopportunity,
  submitGgcspAggregateJudgeData,
} from '../../../services/gcspServices';
import { getCurrentMonth } from '../../../util/commonUtil';
import { GcspPostChangeKeys } from '../../../util/commonFunctions';
import { userOnboardingSubmit } from '../../../services/commonServices';

const CustomSubmitAcknowledgmentModal = ({
  show,
  headerText,
  message,
  onClose,
  closeButtonText,
  onButtonClicked,
  bulletPoints,
}) => {
  const [showFailureSubmitModal, setShowFailureSubmitModal] =
    useRecoilState(Pl_Failure_Modal_State);
  const [showSubmitSuccessModal, setShowSubmitSuccessModal] = useRecoilState(
    Pl_Submit_Success_Modal_State,
  );
  const [quarterData, setQuarterData] = useRecoilState(Recoil_Gcsp_Quarter_State);
  const [allMonthData, setAllMonthData] = useRecoilState(All_Month_Data_State);
  const currentUser = useRecoilValue(Current_User);
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const CurrentMonth = getCurrentMonth(systemDateTime);
  let TodaysDate = systemDateTime ? new Date(systemDateTime) : new Date();
  const handlePostData = async () => {
    const ACCOUNTID = currentUser.account_id;
    const EMAIL = currentUser.email;
    const MONTH = quarterData.month;
    const YEAR = quarterData.fiscal_year;
    const QUARTER = quarterData.quarter;

    const QuarterStartMonth = quarterData.quarter_start_month;

    let REQ_BODY = []; // Jugde Data
    let REQ_BODY_1 = []; // Jugde Data
    let REQ_BODY_2 = []; // Rolling Judge Data
    let REQ_BODY_3 = {}; // Aggregate Jugde Data

    const result = [];
    Object.keys(allMonthData).forEach((key, index) => {
      const item = allMonthData[key];
      if (item.Your_Judge) {
        result[index] = { ...item.Your_Judge[0] };
      }
    });

    let isRollingData = true;
    let SubmissionType = 'month';

    REQ_BODY_1 = result.find(obj => obj.month === CurrentMonth);

    if (Object.keys(result).length !== 0) {
      REQ_BODY_1 = GcspPostChangeKeys([REQ_BODY_1], SubmissionType, false, MONTH);
    }

    if (Object.keys(result).length !== 0) {
      REQ_BODY_2 = GcspPostChangeKeys(result, SubmissionType, isRollingData, MONTH);
    }

    if (CurrentMonth === QuarterStartMonth) {
      SubmissionType = 'quarter';

      if (Object.keys(result).length !== 0) {
        REQ_BODY = GcspPostChangeKeys(result, SubmissionType, false, MONTH);
      }

      for (let obj of REQ_BODY) {
        for (let key in obj) {
          if (key !== 'year') {
            if (REQ_BODY_3.hasOwnProperty(key) && key !== 'submission_type') {
              REQ_BODY_3[key] += obj[key];
            } else {
              REQ_BODY_3[key] = obj[key];
            }
          }
        }
      }
    }

    const userOnboardingRequestBody = {
      email: currentUser.email,
      role: currentUser.role,
      performing_segment: currentUser.account_id,
      onboarding_date: TodaysDate,
    };
    JSON.stringify(userOnboardingRequestBody);

    REQ_BODY_1 = JSON.stringify(REQ_BODY_1[0]);

    try {
      const userOnboarding = userOnboardingSubmit(userOnboardingRequestBody);
      if ((await userOnboarding).status == 200) {
        // If Response true
        const response = await submitGCSPopportunity(
          ACCOUNTID,
          EMAIL,
          MONTH,
          YEAR,
          QUARTER,
          REQ_BODY_1,
          REQ_BODY_2,
        );
        if (response) {
          // If Response true
          if (CurrentMonth === QuarterStartMonth) {
            const postAggregateJudgeData = submitGgcspAggregateJudgeData(
              ACCOUNTID,
              EMAIL,
              MONTH,
              YEAR,
              QUARTER,
              REQ_BODY_3,
            );
            if (postAggregateJudgeData) {
              // If Response true
              setShowSubmitSuccessModal(true); // Showing Success Modal When Response is 200
            } else {
              setShowFailureSubmitModal(true); // Showing Error Modal if Agggregate API Fail
            }
          } else {
            setShowSubmitSuccessModal(true); // Showing Success Modal When Response is 200
          }
        } else {
          setShowFailureSubmitModal(true); // Showing Error Modal if any of Judge Data,Rolling,Updategcspforecast APIs Fail
        }
      } else {
        setShowFailureSubmitModal(true); // Showing Error Modal if User Onboarding API Fail
      }
    } catch (error) {
      setShowFailureSubmitModal(true); // Showing Error Modal for any other error
    }
  };

  const Header = ({ children }) => <HeaderWrapper>{children}</HeaderWrapper>;
  const bodyContent = (
    <BodyContent>
      {message}
      {bulletPoints &&
        bulletPoints.map((point, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={rightArrowImage}
              alt=" "
              style={{ width: '10px', height: '10px', marginRight: '10px' }}
            />
            <span>{point}</span>
          </div>
        ))}
    </BodyContent>
  );
  const headerTitle = <span style={{ marginLeft: 11, fontSize: 16 }}>{headerText}</span>;

  return (
    <>
      <MotifModal variant="alt" show={show} onClose={onClose} style={{ width: '485px' }}>
        <MotifModalHeader>
          <Header>
            <MotifIcon style={{ color: '#FF9831', lineHeight: 1 }} src={alertIcWarning24px} />
            {headerTitle}
          </Header>
        </MotifModalHeader>
        <MotifModalBody>
          <ParagraphStyle> {bodyContent}</ParagraphStyle>
        </MotifModalBody>
        <MotifModalFooter>
          <MotifButton
            variant="primary"
            type="button"
            onClick={() => {
              handlePostData();
              onButtonClicked();
            }}
          >
            {BUTTON_TITLE.SUBMIT}
          </MotifButton>
          <MotifButton variant="secondary" type="button" onClick={onButtonClicked}>
            {BUTTON_TITLE.CANCEL}
          </MotifButton>
        </MotifModalFooter>
      </MotifModal>
    </>
  );
};
export default CustomSubmitAcknowledgmentModal;
